import $ from 'jquery'

class Example {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables

		this.events()
		this.activeFilters = []
		this.resultContainer = $('.blog-results')
		this.loadingSpinner = $('.spinner_container')
		this.url = '/articles/?cat='
		// make a timer
		this.myTimer = null
	}

	//?events
	events() {
		let myObj = this
		// on load
		$(window).on('load', () => {
			// udpate filters
			myObj.CheckURLParam()
			myObj.UpdateOrderSelector()
		})

		$('.all_form_input').on('change', function () {
			// clear active filters
			myObj.activeFilters = []
			// clear all checkboxes
			$('.blog_form_input').prop('checked', false)
			console.log(myObj.activeFilters)
			myObj.clearResults()
			myObj.goToUpdatedURL()
		})

		// select dropdown
		$('#x-filter').on('change', function () {
			// get the value of the select
			var value = $(this).val()
			console.log(value)
			myObj.AddOrderToURL(value)
		})

		$('.blog_form_input').on('change', function () {
			// log the value
			console.log($(this).val())
			// log the checked status
			console.log($(this).prop('checked'))

			console.log($(this).data('idnum'))

			myObj.updateFilters($(this).data('idnum'))
			$('.all_form_input').prop('checked', false)
			// restart timer on every new click
			myObj.goToUpdatedURL()
		})

		$('.close').on('click', function () {
			console.log('close')
			// add hide class to parent
			$('.mobile_filters').addClass('hide')
		})
		$('.filter_click').on('click', function () {
			console.log('filter_click')
			// remove hide class to parent
			$('.mobile_filters').removeClass('hide')
		})

		$('.close_btn').on('click', function () {
			$('.mobile_nav').addClass('hide')
		})
		$('.hamberger').on('click', function () {
			$('.mobile_nav').removeClass('hide')
		})
	}

	clearResults() {
		this.resultContainer.html('')
		this.loadingSpinner.removeClass('hide')
	}

	updateFilters = (item) => {
		this.clearResults()
		// remove 'option_' from item
		// item = item.replace('option_', '')
		// if item is in array
		if (this.activeFilters.includes(item)) {
			// remove item from array
			this.activeFilters.splice(this.activeFilters.indexOf(item), 1)
		} else {
			// add item to array
			this.activeFilters.push(item)
		}
		console.log(this.activeFilters)
		// if array is empty
		if (this.activeFilters.length == 0) {
			// check all

			// default to all
			/// find checkbox with value of filter
			console.log('no filters default to all activate all checkbox')
			// wait 1/5 of a second
			setTimeout(() => {
				// run filter function
				$('.all_form_input').prop('checked', true)
			}, 200)
		} else {
			//? run filter function
			console.log('url is ' + this.generateURL())
			// wait 1 secound and go to url
		}
	}
	UpdateOrderSelector = (order) => {
		// get order from params
		var order = this.getUrlParameter('order')
		// if order is asc
		if (order == 'asc') {
			// select asc
			$('#x-filter').val('asc')
		}
		// if order is desc
		if (order == 'desc') {
			// select desc
			$('#x-filter').val('desc')
		}
	}

	// add order to URL
	AddOrderToURL = (order) => {
		// if value is asc
		if (order == 'asc') {
			this.generateURL()
			// add order to url
			this.url = this.url + '&orderby=title&order=asc'
		}
		if (order == 'desc') {
			this.generateURL()
			// add order to url
			this.url = this.url + '&orderby=title&order=desc'
		}
		if (order == 'date') {
			this.generateURL()
		}
		console.log(this.url)
		// go to url
		location.href = this.url
	}

	generateURL = () => {
		// example: ?cat=22,21,23
		// create a url using the active filters
		var url = '/articles/?cat=' + this.activeFilters.join(',')
		// return the url
		this.url = url
		return url
	}

	goToUpdatedURL = () => {
		let myObj = this
		clearTimeout(myObj.myTimer)
		myObj.myTimer = setTimeout(function () {
			location.href = myObj.generateURL()
		}, 1000)
	}

	//? 3. methods (functions)
	CheckURLParam(params) {
		// get the current url
		var url = window.location.href
		// get last peramiter of url
		var allPerams = url.split('/')

		// check if category is in url
		if (allPerams[3] == 'category') {
			// get the category
			var category = allPerams[4]
			// find checkbox with 'all' and uncheck it
			$('.all_form_input').prop('checked', false)
			// add category to active filters
			// this.activeFilters.push(category)

			// find checkbox with value of filter
			$('#option_' + category).prop('checked', true)
			// get categoryh idnum
			var idnum = $('#option_' + category).data('idnum')
			// add category to active filters
			this.activeFilters.push(idnum)
		} else {
			// get ?cat peramiter
			var categories = this.getUrlParameter('cat')

			// if ?cat peramiter is not empty
			if (categories != undefined) {
				// split ?cat peramiter into array
				categories = categories.split(',')
				// find checkbox with 'all' and uncheck it
				$('.all_form_input').prop('checked', false)
				// turn array items into numbers
				categories = categories.map(function (item) {
					return parseInt(item, 10)
				})
				// add categories to active filters
				this.activeFilters = categories

				$('.blog_form_input').each(function () {
					if (categories.includes($(this).data('idnum'))) {
						$(this).prop('checked', true)
					}
				})
			}

			console.log(this.activeFilters)
		}
	}

	getUrlParameter(sParam) {
		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=')

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined
					? true
					: decodeURIComponent(sParameterName[1])
			}
		}
	}
}

export default Example
